export default class Print {
  constructor(button) {
    this.dom = {
      button,
    };

    this.dom.button.addEventListener('click', () => window.print());
  }
}
